// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"ButtonPrimary_buttonPrimary__RKKZW"};